var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDatabases(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216.51 263.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e2c4ff;}.cls-2{fill:#a4fbc4;}.cls-3{fill:#00008b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_13"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 60.54,
    cy: 210.14,
    r: 7.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 35.97,
    cy: 210.14,
    r: 7.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 86.24,
    cy: 210.14,
    r: 7.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 60.54,
    cy: 117.54,
    r: 7.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 35.97,
    cy: 117.54,
    r: 7.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 86.24,
    cy: 117.54,
    r: 7.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 60.54,
    cy: 24.95,
    r: 7.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 35.97,
    cy: 24.95,
    r: 7.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 86.24,
    cy: 24.95,
    r: 7.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m30.42,237.7h156.62c3.04,0,5.5-2.2,5.5-4.91s-2.46-4.91-5.5-4.91H30.42c-3.04,0-5.5,2.2-5.5,4.91s2.46,4.91,5.5,4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m201.04,92.6h-7.85v-14.42h7.85c8.53,0,15.47-6.94,15.47-15.47V15.47c0-8.53-6.94-15.47-15.47-15.47H15.46C6.94,0,0,6.94,0,15.47v47.24c0,8.53,6.94,15.47,15.46,15.47h11.63v14.42h-11.63c-8.53,0-15.46,6.94-15.46,15.47v47.24c0,8.53,6.94,15.47,15.46,15.47h11.88v14.42h-11.88c-8.53,0-15.46,6.94-15.46,15.47v47.24c0,8.53,6.94,15.47,15.46,15.47h185.58c8.53,0,15.47-6.94,15.47-15.47v-47.24c0-8.53-6.94-15.47-15.47-15.47h-8.1v-14.42h8.1c8.53,0,15.47-6.94,15.47-15.47v-47.24c0-8.53-6.94-15.47-15.47-15.47Zm3.43,108.06v47.24c0,1.89-1.54,3.43-3.43,3.43H15.46c-1.89,0-3.43-1.54-3.43-3.43v-47.24c0-1.89,1.54-3.43,3.43-3.43h185.58c1.89,0,3.43,1.54,3.43,3.43ZM12.03,62.71V15.47c0-1.89,1.54-3.43,3.43-3.43h185.58c1.89,0,3.43,1.54,3.43,3.43v47.24c0,1.89-1.54,3.43-3.43,3.43H15.46c-1.89,0-3.43-1.54-3.43-3.43Zm25.06,15.47h146.09v14.42H37.09v-14.42Zm146.35,106.78H36.84v-14.18h146.6v14.18Zm21.03-29.65c0,1.89-1.54,3.43-3.43,3.43H15.46c-1.89,0-3.43-1.54-3.43-3.43v-47.24c0-1.89,1.54-3.43,3.43-3.43h185.58c1.89,0,3.43,1.54,3.43,3.43v47.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m187.03,135.28H30.42c-3.04,0-5.5,2.2-5.5,4.91s2.46,4.91,5.5,4.91h156.62c3.04,0,5.5-2.2,5.5-4.91s-2.46-4.91-5.5-4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m187.03,42.68H30.42c-3.04,0-5.5,2.2-5.5,4.91s2.46,4.91,5.5,4.91h156.62c3.04,0,5.5-2.2,5.5-4.91s-2.46-4.91-5.5-4.91Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDatabases);
export default __webpack_public_path__ + "static/media/icon-databases.0500b1a9dd302146f5708ed91894a468.svg";
export { ForwardRef as ReactComponent };